import { IShimmerColors, IShimmerProps, Shimmer, ShimmerElementType } from '@fluentui/react';

//
// The missing v8 wrapper. Nothing in this app may import a Fluent component directly, and the
// placeholder recipes did exactly that; this is the one door they go through instead.
//
// The element-type enum and the colour shape travel with it: a caller describing a placeholder needs
// both, and re-exporting them here keeps `@fluentui/react` out of feature code.
//

export interface IPShimmerProps extends IShimmerProps {}

export { ShimmerElementType as IPShimmerElementType };
export type { IShimmerColors as IPShimmerColors };

export const IPShimmer = (props: IPShimmerProps) => {
  return <Shimmer {...props} />;
};
